// extracted by mini-css-extract-plugin
module.exports = {"title":"printing-module__title___2b9-C","text":"printing-module__text___zbHT-","root":"printing-module__root___32pBo"};